module.exports = __webpack_public_path__ + "img/main_home4.d50d9c7.png";